// import needed stuff
import { Api } from '@moxiltd/moxijs/src/api/api';
import { ApiClientFactory } from '@moxiltd/moxijs/src/api/apiclientfactory';
import { FrontendForm } from '@moxiltd/moxijs/src/form/frontendform';
import { i18n } from '@moxiltd/moxijs/src/i18n';
import CookieInfo from './cookie-info/cookie-info';
import { Form } from './form';
import ProjectDetailMore from './project-detail-more/project-detail-more';
import ProjectFilter from './project-filter/project-filter';
import SimpleAccordion from './simple-accordion/simple-accordion';
import {Slider} from './swipe-instatiator/swipe-instantiator';
import { WindowHelper } from './WindowHelper';
import WorkListActiveState from './work-list-active-state/work-list-active-state';
import Lightbox from './images-handler/lightbox';

import './downloads';
import './mobile-menu';
import './sticky-navigation';
import './team';

// make moxi functions available from outside, e.g. templates
window.moxi = {
    Api,
    ApiClientFactory,
    i18n,
    FrontendForm,
    Form,
    Lightbox,
    ProjectFilter,
    SimpleAccordion,
    WindowHelper,
    WorkListActiveState,
};

window.addEventListener('load', () => {
    new CookieInfo('.cookie-info .button');
    new ProjectDetailMore();
    new ProjectFilter('ul[data-filter="data-project-uses"]');
    new ProjectFilter('ul[data-filter="data-project-type"]');
    new SimpleAccordion('#thats-an-accordion .is-accordion-further-informations-title');
    new Slider();
    new WorkListActiveState();
    new Lightbox();
}, true);
